import { getDictPhrase } from "../../../../helpers/common";
export const getSelectionTitleBulletCastProps = (selection, state) => {
    const castPosition = selection.castBetPosition && selection.castBetPosition > 0
        ? ` ${getDictPhrase(state.dict, `CastPosition${selection.castBetPosition}`)}`
        : "";
    return {
        name: `${selection.selectionDisplayName}${castPosition}`,
        status: selection.settlementStatus
    };
};
//# sourceMappingURL=getSelectionTitleBulletCastProps.js.map